import React from 'react';

// Common SVG props
const iconProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const BoardIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
    <path d="M9 14h6" />
    <path d="M9 10h6" />
  </svg>
);

export const ChatIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const ThemeIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 3a9 9 0 1 0 9 9" />
    <path d="M21 12a9 9 0 0 0-9-9v18a9 9 0 0 0 9-9z" fill="currentColor" />
  </svg>
);

export const HexagonIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
  </svg>
);

export const CloseIcon = (props) => (
  <svg {...iconProps} {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const ChevronLeftIcon = (props) => (
  <svg {...iconProps} {...props}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg {...iconProps} {...props}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const PlusIcon = (props) => (
  <svg {...iconProps} {...props}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg {...iconProps} {...props}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const LightningIcon = (props) => (
  <svg {...iconProps} {...props}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

export const LockIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export const PlantIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 22a8 8 0 0 1-8-8c0-3.5 2.5-6.5 6-7.5" />
    <path d="M12 22a8 8 0 0 0 8-8c0-3.5-2.5-6.5-6-7.5" />
    <path d="M12 22v-8" />
    <path d="M12 14c-2-2-5-2-7-1 0 0 2-3 5-3 1.5 0 3 .5 4 1.5" />
    <path d="M12 14c2-2 5-2 7-1 0 0-2-3-5-3-1.5 0-3 .5-4 1.5" />
    <path d="M12 8c-1-1-3-1.5-5-1 0 0 1-2 3.5-2.5 1.5-.2 3 .2 4.5 1.5" />
    <path d="M12 8c1-1 3-1.5 5-1 0 0-1-2-3.5-2.5C12 3.3 10.5 3.7 9 5" />
  </svg>
);

export const WindIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2" />
  </svg>
);

export const PencilIcon = (props) => (
  <svg {...iconProps} {...props}>
    <line x1="18" y1="2" x2="22" y2="6" />
    <path d="M7.5 20.5 19 9l-4-4L3.5 16.5 2 22z" />
  </svg>
);

export const GlovesIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M14 6V4a2 2 0 0 0-4 0v2m-4 0a2 2 0 0 0-4 0v16h12V6M6 6h8" />
  </svg>
);

export const GogglesIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="2" y="8" width="8" height="6" rx="2" />
    <rect x="14" y="8" width="8" height="6" rx="2" />
    <path d="M10 11h4" />
    <path d="M2 11c-2-4 4-8 10-8s12 4 10 8" />
  </svg>
);

export const BootsIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M4 3v11c0 2 2 4 4 4h8c2 0 4-2 4-4V3" />
    <path d="M4 18h16v3H4z" />
  </svg>
);

export const MaskIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 5C6 5 2 8 2 12c0 4 4 10 10 10s10-6 10-10C22 8 18 5 12 5Z" />
    <path d="M7 12h10" />
    <path d="M12 12v5" />
  </svg>
);

export const VestIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M4 9c0-3 3-5 5-5h6c2 0 5 2 5 5v11H4V9z" />
    <path d="M12 4v16" />
    <path d="M8 4L4 9" />
    <path d="M16 4l4 5" />
  </svg>
);

export const ShieldIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

export const FlaskIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M9 3H15" />
    <path d="M10 3V12L4.5 20.5A1.5 1.5 0 0 0 6 23H18A1.5 1.5 0 0 0 19.5 20.5L14 12V3" />
    <path d="M6 14H18" />
  </svg>
);

export const SyncIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M21 2v6h-6" />
    <path d="M3 12a9 9 0 0 1 15-6.7L21 8" />
    <path d="M3 22v-6h6" />
    <path d="M21 12a9 9 0 0 1-15 6.7L3 16" />
  </svg>
);

export const WheatIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M2 22 22 2" />
    <path d="M7.5 16.5C10 16.5 12 14.5 12 12A4.5 4.5 0 1 0 7.5 12V16.5Z" />
    <path d="M12 12C14.5 12 16.5 10 16.5 7.5A4.5 4.5 0 1 0 12 7.5V12Z" />
    <path d="M16.5 7.5C19 7.5 21 5.5 21 3A4.5 4.5 0 1 0 16.5 3V7.5Z" />
    <path d="M7.5 16.5A4.5 4.5 0 1 1 3 21H7.5V16.5Z" />
    <path d="M12 12A4.5 4.5 0 1 1 7.5 16.5H12V12Z" />
    <path d="M16.5 7.5A4.5 4.5 0 1 1 12 12H16.5V7.5Z" />
  </svg>
);

export const SirenIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 2v2" />
    <path d="M6 4 7.5 5.5" />
    <path d="M18 4l-1.5 1.5" />
    <path d="M12 22H5a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-7Z" />
    <path d="M7 11V8a5 5 0 0 1 10 0v3" />
  </svg>
);

export const CameraIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);

export const MenuIcon = (props) => (
  <svg {...iconProps} {...props}>
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export const ArrowUpIcon = (props) => (
  <svg {...iconProps} {...props}>
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
);

export const SunIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </svg>
);

export const MoonIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
  </svg>
);

// Overlay Symbols
export const BugIcon = (props) => (
  <svg {...iconProps} {...props}>
    <rect x="8" y="6" width="8" height="14" rx="4" />
    <path d="m19 7-3 2" />
    <path d="m5 7 3 2" />
    <path d="m19 19-3-2" />
    <path d="m5 19 3-2" />
    <path d="M20 13h-4" />
    <path d="M4 13h4" />
    <path d="m10 4 1 2" />
    <path d="m14 4-1 2" />
  </svg>
);

export const NetIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12 2v20" />
    <path d="M2 12h20" />
    <path d="m4.9 4.9 14.2 14.2" />
    <path d="m4.9 19.1 14.2-14.2" />
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);

export const ScissorsIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <line x1="20" y1="4" x2="8.12" y2="15.88" />
    <line x1="14.47" y1="14.48" x2="20" y2="20" />
    <line x1="8.12" y1="8.12" x2="12" y2="12" />
  </svg>
);

export const TransferIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="m15 16 4-4-4-4" />
    <path d="M5 12h14" />
    <path d="m9 8-4 4 4 4" />
    <path d="M19 12H5" />
  </svg>
);

export const HarvestIcon = (props) => (
  <svg {...iconProps} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

export const GearIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const DiamondIcon = (props) => (
  <svg {...iconProps} {...props}>
    <polygon points="12 2 22 12 12 22 2 12 12 2" />
    <circle cx="12" cy="12" r="3" fill="currentColor" />
  </svg>
);

export const WarningIcon = (props) => (
  <svg {...iconProps} {...props}>
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </svg>
);
